module.exports = __webpack_public_path__ + "static/cube21-3815b458e0602cc2350e18eef0c7e631.svg";